import React from 'react';
import { LandingHeader } from './LandingHeader';
import { HeroSection } from './HeroSection';
import { FoodSection } from './FoodSection';
import { BarSection } from './BarSection';
import { PrivateBookingSection } from './PrivateBookingSection';
import { VisitAndHoursSection } from './VisitAndHoursSection';
import { LandingFooter } from './LandingFooter';
import { LegalModalType } from '../LegalModal';

interface LandingPageProps {
  onOpenOrderApp: () => void;
  onOpenStaffPortal: () => void;
  onOpenLegalModal: (type: LegalModalType) => void;
}

export const LandingPage: React.FC<LandingPageProps> = ({
  onOpenOrderApp,
  onOpenStaffPortal,
  onOpenLegalModal
}) => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 76;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = el.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="os-landing-root">
      {/* Background Animated Hearth Atmosphere & Rising Embers */}
      <div className="os-bg-ambient" aria-hidden="true">
        <div className="os-glow-orb-1" />
        <div className="os-glow-orb-2" />
        <div className="os-embers-container">
          <div className="os-ember" />
          <div className="os-ember" />
          <div className="os-ember" />
          <div className="os-ember" />
          <div className="os-ember" />
          <div className="os-ember" />
          <div className="os-ember" />
        </div>
      </div>

      {/* 1. Header with clear visible logo, smooth scroll links, and single 'Book Your Table' CTA */}
      <LandingHeader
        onOpenOrderApp={onOpenOrderApp}
      />

      <main>
        {/* 2. Hero Section (Home) */}
        <HeroSection
          onOpenOrderApp={onOpenOrderApp}
          onExploreFood={() => scrollTo('food')}
        />

        {/* 3. Food Section (Wood-Fired Kitchen) */}
        <FoodSection
          onOpenOrderApp={onOpenOrderApp}
        />

        {/* 4. Bar Section (Craft Cocktails & Nordic Bar) */}
        <BarSection
          onOpenOrderApp={onOpenOrderApp}
        />

        {/* 5. Private Booking Section (Events, Celebrations & Form) */}
        <PrivateBookingSection />

        {/* 6. Hours, Location (Aleksanterinkatu 18) & Safety (Oiva) */}
        <VisitAndHoursSection
          onOpenOrderApp={onOpenOrderApp}
          onOpenLegalModal={onOpenLegalModal}
        />
      </main>

      {/* 7. Clean Editorial Footer */}
      <LandingFooter
        onOpenOrderApp={onOpenOrderApp}
        onOpenStaffPortal={onOpenStaffPortal}
        onOpenLegalModal={onOpenLegalModal}
      />
    </div>
  );
};
